import { getFiltersMap } from '../Components/ReactDataGrid/SortFilterTables';

export default function buildNumericFilters(defaultFilterValue) {
  const paramsMap = {};

  defaultFilterValue.forEach(filter => {
    if (filter.value && filter.type === 'number') {
      const { name, value, operator } = filter;
      const map = getFiltersMap().get(name) ?? filter.name;

      paramsMap[map] = value;

      let baseValue: number;
      let offsetNegative: number | string;
      let offsetPositive: number | string;
      let floatBuffer: number;

      const isFirstOrLastRef = name === 'firstRef' || name === 'lastRef';

      if (filter?.integer === true || isFirstOrLastRef) {
        baseValue = parseInt(value);
        offsetNegative = baseValue - 1;
        offsetPositive = baseValue + 1;
        floatBuffer = 0;
      } else {
        baseValue = parseFloat(value);
        floatBuffer = 0.005;
        offsetNegative = (baseValue - floatBuffer).toFixed(4);
        offsetPositive = (baseValue + floatBuffer).toFixed(4);
      }

      switch (operator) {
        case 'eq':
          if (isFirstOrLastRef) {
            paramsMap[`min_${map}`] = baseValue;
            paramsMap[`max_${map}`] = baseValue;
          } else {
            paramsMap[`min_${map}`] = baseValue - floatBuffer;
            paramsMap[`max_${map}`] = baseValue + floatBuffer;
          }
          break;
        case 'gt':
          paramsMap[`min_${map}`] = offsetPositive;
          break;
        case 'gte':
          paramsMap[`min_${map}`] = baseValue;
          break;
        case 'lt':
          paramsMap[`max_${map}`] = offsetNegative;
          break;
        case 'lte':
          paramsMap[`max_${map}`] = baseValue;
          break;
      }
    }
  });

  return paramsMap;
}
